import React from 'react';
import { Bars } from 'react-loader-spinner';
import './Loader.css'; // Import CSS for styling

const Loader = ({ isLoading }) => {
    return (
        isLoading && (
            <div className="loader-container" style={{backgroundColor:"rgba(255, 255, 255, 0.7)"}}>
                <Bars
                    height="80"
                    width="80"
                    radius="9"
                    color="#333333"
                    ariaLabel="loading-indicator"
                />
            </div>
        )
    );
};

export default Loader;
